var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

module.exports = function() {

  $( '[data-scroll-to="top"]' ).on( "click", function() {
    $( "html" ).velocity( "scroll", {
      duration: 800,
      offset: 0
    });
  });

};
